import React from "react";
import Layout from "../components/common/Layout";

const LegalNotice = () => {



  return (

    <Layout>

      <section className="relative min-h-screen text-white overflow-hidden">


        <div className="relative z-10 flex items-center justify-center min-h-screen px-6 py-20 backdrop-blur-md">
          <div className="bg-white/90 dark:bg-[#112626]/90 rounded-xl shadow-xl p-10 max-w-4xl text-gray-800 dark:text-gray-100 text-justify">


            <div className="container mx-auto p-6 max-w-4xl">
              <h1 className="text-3xl font-bold mb-6 text-center">LEGAL NOTICE</h1>
              <p className="mb-4 text-center">Last updated: 27/02/2025</p>

              <h2 className="text-2xl font-semibold mt-6">1. General Information</h2>
              <p className="mb-4">
                In accordance with the duty of information established in Article 10 of Law 34/2002, of July 11, on Information Society Services and Electronic Commerce (LSSI-CE), users of this website are informed of the following identifying details:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li><strong>Owner:</strong> Slowork S.L</li>
                <li><strong>Registered Address:</strong> Rodrigo Caro 7, Sevilla, 41004</li>
                <li><strong>CIF/NIF:</strong> B75950444</li>
                <li><strong>Email Address:</strong> sloworking.adm@gmail.com</li>
                <li><strong>Contact Phone:</strong> +34 692390453</li>
                <li><strong>Website:</strong> www.slowork.app</li>
              </ul>

              <h2 className="text-2xl font-semibold mt-6">2. Purpose and Scope</h2>
              <p className="mb-4">
                This Legal Notice governs access, navigation, and use of the Slow Work website and platform, which provides a digital tool for searching and booking coliving and coworking spaces for digital nomads and remote workers. Use of this website implies full and unconditional acceptance of all provisions included in this Legal Notice.
              </p>

              <h2 className="text-2xl font-semibold mt-6">3. Terms of Use</h2>

              <h3 className="text-xl font-semibold mt-4">3.1. Users</h3>
              <p className="mb-4">
                Access and/or use of this website confers the status of user, implying acceptance of this Legal Notice from the moment of access and/or use.
              </p>

              <h3 className="text-xl font-semibold mt-4">3.2. Permitted Use</h3>
              <p className="mb-4">
                The user agrees to use the website and the services offered in accordance with current legislation, good faith, and public order. The use of the site for unlawful purposes or purposes that may cause harm to Slowork or third parties is prohibited.
              </p>

              <h3 className="text-xl font-semibold mt-4">3.3. Registration and Authentication</h3>
              <p className="mb-4">
                Some functionalities require registration. The user agrees to provide truthful information and keep their data up to date. Users are responsible for safeguarding their access credentials.
              </p>

              <h3 className="text-xl font-semibold mt-4">3.4. Booking and Cancellation Terms</h3>
              <p className="mb-4">
                By using the platform to make reservations, the user accepts the payment, modification, and cancellation terms established in the specific terms and conditions of each offer. Slowork is not responsible for disputes between users and service providers.
              </p>

              <h2 className="text-2xl font-semibold mt-6">4. Intellectual and Industrial Property</h2>
              <p className="mb-4">
                All website content (texts, images, logos, software, structure, and design) is the property of Slowork or authorized third parties, protected by intellectual and industrial property regulations. Reproduction, distribution, or modification without express authorization from the owner is prohibited.
              </p>

              <h2 className="text-2xl font-semibold mt-6">5. Disclaimer of Liability</h2>
              <p className="mb-4">Slowork is not responsible for:</p>
              <ul className="list-disc pl-6 mb-4">
                <li>Misuse of the website by users.</li>
                <li>Continuity of website operation or updates.</li>
                <li>The presence of viruses or malicious elements.</li>
                <li>Links to third-party websites, which have their own terms and conditions.</li>
                <li>Cancellations, refunds, or non-compliance by service providers booked through the platform.</li>
              </ul>

              <h2 className="text-2xl font-semibold mt-6">6. Personal Data Protection</h2>
              <p className="mb-4">
                In accordance with the General Data Protection Regulation (EU) 2016/679 (GDPR) and Organic Law 3/2018 on Personal Data Protection and Digital Rights Guarantee (LOPDGDD), we inform you that personal data collected through the website will be processed in accordance with our <a href="/privacy-policy" className="underline">Privacy Policy</a>.
              </p>
              <p className="mb-4">
                Users may exercise their rights of access, rectification, deletion, objection, portability, and restriction of processing by submitting a request to <strong>sloworking.adm@gmail.com</strong>.
              </p>

              <h2 className="text-2xl font-semibold mt-6">7. Use of Cookies</h2>
              <p className="mb-4">
                This website uses first- and third-party cookies to enhance user experience and analyze navigation. For more information, see our <a href="/cookies-policy" className="underline">Cookies Policy</a>. Users can manage their cookie preferences at any time.
              </p>

              <h2 className="text-2xl font-semibold mt-6">8. Applicable Law and Jurisdiction</h2>
              <p className="mb-4">
                For the resolution of any disputes or conflicts related to this website, Spanish legislation will apply, and the parties submit to the Courts and Tribunals of Sevilla, Spain.
              </p>

              <h2 className="text-2xl font-semibold mt-6">9. Dispute Resolution</h2>
              <p className="mb-4">
                In the event of a dispute, users may opt for alternative dispute resolution mechanisms, such as mediation or arbitration, before resorting to legal action.
              </p>
            </div>
          </div>
        </div>

      </section>

    </Layout>
  );


};

export default LegalNotice;
